import Rand from "../../util/Rand";
import { MonsterBrainIds } from "./MonsterBrainIds";
import MonsterDescription from "./MonsterDescription";
import { MonsterSpriteNames } from "./MonsterSpriteNames";

export const MonsterDescriptions = {
    ANT: new MonsterDescription('1', MonsterSpriteNames.PEST_ANT_10, MonsterBrainIds.BASIC),
    SPIDER1: new MonsterDescription('2', MonsterSpriteNames.PEST_SPIDER_20, MonsterBrainIds.BASIC),
    SPIDER2: new MonsterDescription('3', MonsterSpriteNames.PEST_SPIDER_21, MonsterBrainIds.BASIC),
    SPIDER3: new MonsterDescription('4', MonsterSpriteNames.PEST_SPIDER_22, MonsterBrainIds.BASIC),
    WORM1: new MonsterDescription('5', MonsterSpriteNames.PEST_WORM_30, MonsterBrainIds.BASIC),
    WORM2: new MonsterDescription('6', MonsterSpriteNames.PEST_WORM_31, MonsterBrainIds.BASIC),
    WORM4: new MonsterDescription('7', MonsterSpriteNames.PEST_WORM_33, MonsterBrainIds.BASIC),
    WORM5: new MonsterDescription('8', MonsterSpriteNames.PEST_WORM_34, MonsterBrainIds.BASIC),
    BALL: new MonsterDescription('9', MonsterSpriteNames.PEST_BALL, MonsterBrainIds.BASIC),
    SLUG1: new MonsterDescription('10', MonsterSpriteNames.PEST_SLUG_70, MonsterBrainIds.BASIC),
    SLUG2: new MonsterDescription('11', MonsterSpriteNames.PEST_SLUG_71, MonsterBrainIds.BASIC),
    SNAIL1: new MonsterDescription('12', MonsterSpriteNames.PEST_SNAIL_72, MonsterBrainIds.BASIC),
    SNAIL2: new MonsterDescription('13', MonsterSpriteNames.PEST_SNAIL_73, MonsterBrainIds.BASIC),
    SLIME01: new MonsterDescription('14', MonsterSpriteNames.SLIME_BLUE_00, MonsterBrainIds.BASIC),
    SLIME02: new MonsterDescription('15', MonsterSpriteNames.SLIME_BROWN_01, MonsterBrainIds.BASIC),
    SLIME03: new MonsterDescription('16', MonsterSpriteNames.SLIME_WHITE_02, MonsterBrainIds.BASIC),
    SLIME04: new MonsterDescription('17', MonsterSpriteNames.SLIME_GREEN_03, MonsterBrainIds.BASIC),
    SLIME05: new MonsterDescription('18', MonsterSpriteNames.SLIME_PINK_04, MonsterBrainIds.BASIC),
    SLIME06: new MonsterDescription('19', MonsterSpriteNames.SLIME_MUCUS_GREEN_40, MonsterBrainIds.BASIC),
    SLIME07: new MonsterDescription('20', MonsterSpriteNames.SLIME_MUCUS_BLUE_41, MonsterBrainIds.BASIC),
    SLIME08: new MonsterDescription('21', MonsterSpriteNames.SLIME_CORRODED_20, MonsterBrainIds.BASIC),
    SLIME09: new MonsterDescription('22', MonsterSpriteNames.SLIME_SEEING_21, MonsterBrainIds.BASIC),
    SLIME10: new MonsterDescription('23', MonsterSpriteNames.SLIME_ORANGE_22, MonsterBrainIds.BASIC),
    SLIME11: new MonsterDescription('24', MonsterSpriteNames.SLIME_MINI_BLUE_30, MonsterBrainIds.BASIC),
    SLIME12: new MonsterDescription('25', MonsterSpriteNames.SLIME_MINI_31, MonsterBrainIds.BASIC),
    SLIME13: new MonsterDescription('26', MonsterSpriteNames.SLIME_MINI_ORANGE_32, MonsterBrainIds.BASIC),
};

function buildMonsterDescriptionMap() {
    const map = {};

    for (let monsterDescription of Object.values(MonsterDescriptions)){
        map[monsterDescription.id] = monsterDescription;
    }    

    return map;
}

function buildMonsterDescriptionArray() {
    const monsters = [];

    for (let monsterDescription of Object.values(MonsterDescriptions)){
        monsters.push(monsterDescription);
    }    

    return monsters;
}

export const MonsterDescriptionMap = buildMonsterDescriptionMap();

const MonsterDescriptionArray = buildMonsterDescriptionArray();

/**
 * @returns {MonsterDescription[]}
 */
export function getRandomMonsterDescriptions() {
    const monsters = [];

    monsters.push(MonsterDescriptionArray[Rand.randomInt(MonsterDescriptionArray.length)]);
    monsters.push(MonsterDescriptionArray[Rand.randomInt(MonsterDescriptionArray.length)]);

    return monsters;
}